'use client';

import { Container, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

import MapSection from '@/components/MapSection';
import colors from '@/styles/themes/colors';

import styles from './HeroSection.module.scss';

const HeroSection = () => {
  const t = useTranslations('office.hero');

  return (
    <Container maxWidth={false} disableGutters classes={{ root: styles.root }} className={styles.container}>
      <MapSection>
        <Stack className={styles.content} spacing={3}>
          <Typography variant="h1" component="h1" color={colors.white}>
            {t('title')}
          </Typography>
          <Typography variant="body1" color={colors.white} className={styles.description}>
            {t('description')}
          </Typography>
        </Stack>
      </MapSection>
    </Container>
  );
};

export default HeroSection;
